import './polyfills';

import React from 'react';

import ReactDOM from 'react-dom';

import * as serviceWorker from '@ttstr/components/ServiceWorker/ServiceWorker';

import { injectGoogle, injectMetaPixels, injectSpotifyPixel, injectTikTokPixels } from '@ttstr/utils';

import App from './App';

injectMetaPixels('1923086435210462');
injectTikTokPixels('D2QS13BC77UCDUAML96G');
injectGoogle('GTM-NQ8NX5MD,G-6LKEQZS3C0');
injectSpotifyPixel('f26b04c9b2744cdb9b4dd70134c8d48b');
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
// serviceWorker.unregister();
